import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import { useEffect } from "react";
import { Link } from "react-router-dom";

// Override default icon
const agriIcon = L.divIcon({
  className: "",
  html: `<div class="agri-marker">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2c-1 3-2 4-4 5 3 1 4 3 4 6 0-3 1-5 4-6-2-1-3-2-4-5z"/><path d="M5 21h14"/><path d="M12 13v8"/></svg>
  </div>`,
  iconSize: [36, 36],
  iconAnchor: [18, 18],
});

const userIcon = L.divIcon({
  className: "",
  html: `<div style="background:#4A6B53;color:#fff;width:20px;height:20px;border-radius:50%;border:4px solid #fff;box-shadow:0 0 0 4px rgba(74,107,83,0.25);"></div>`,
  iconSize: [20, 20],
  iconAnchor: [10, 10],
});

function Recenter({ center, zoom }) {
  const map = useMap();
  useEffect(() => {
    if (center) map.flyTo(center, zoom || map.getZoom(), { duration: 0.8 });
  }, [center, zoom, map]);
  return null;
}

export default function FarmMap({ farms = [], userLocation, activeId, onMarkerClick, height = 600 }) {
  const center = userLocation || [41.5, 12.8]; // Italy center

  return (
    <div style={{ height }} className="w-full rounded-[2rem] overflow-hidden border border-[#E5DCD0] shadow-inner bg-[#F2EBE1]">
      <MapContainer center={center} zoom={userLocation ? 9 : 6} scrollWheelZoom style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {userLocation && (
          <Marker position={userLocation} icon={userIcon}>
            <Popup>La tua posizione</Popup>
          </Marker>
        )}
        {farms.map((f) => (
          <Marker
            key={f.id}
            position={[f.lat, f.lng]}
            icon={agriIcon}
            eventHandlers={{ click: () => onMarkerClick && onMarkerClick(f) }}
          >
            <Popup>
              <div className="min-w-[200px]">
                <div className="font-display font-black text-base text-[#2C312E] mb-1">{f.name}</div>
                <div className="text-xs text-[#58625B] mb-2">{f.city} ({f.province})</div>
                <Link
                  to={`/fattorie/${f.id}`}
                  className="text-xs font-bold text-[#C8795A] underline"
                >
                  Vedi dettagli →
                </Link>
              </div>
            </Popup>
          </Marker>
        ))}
        {activeId && farms.find((f) => f.id === activeId) && (
          <Recenter
            center={[farms.find((f) => f.id === activeId).lat, farms.find((f) => f.id === activeId).lng]}
            zoom={11}
          />
        )}
        {userLocation && <Recenter center={userLocation} zoom={9} />}
      </MapContainer>
    </div>
  );
}
